import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { updateFlowStatus } from 'src/components/Subheader/Subheader.slice';
import { updateGroupBy, receiveViewDefns } from 'src/components/Subheader/Subheader.slice';
import { getGroupBy } from 'src/components/Subheader/Subheader.selectors';
import { fetchProductivityData, receiveViewDefn } from './Productivity.slice';
import {
  inputIsNotNullOrUndefined,
  isScopeDefined,
  isSubheaderLoaded,
  maybeGetComponentProps,
} from 'src/utils/Functions/epicsFunctions';
import { ConfDefnComponentType, ProductivityComponent } from 'configuration-schemas/confdefnComponents';
import { getAggBys } from 'src/pages/Hindsighting/StyleColorReview/StyleColorReview.slice';
import { ListDataOptions } from 'src/worker/pivotWorker.types';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from 'src/pages/AssortmentBuild/Planning.types';

export const productivityLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      receiveViewDefns.type,
      updateFlowStatus.type,
      updateGroupBy.type,
      receiveViewDefn.type,
      receiveScopeConfig.type,
      LENS_ASST_PLAN_REFRESHING_PAGE,
    ),
    map(() => maybeGetComponentProps<ProductivityComponent>(state$.value, ConfDefnComponentType.productivity)),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns }) => {
      const flowStatus = state$.value.subheader.flowStatus.join(',');
      const aggBy = getAggBys(getGroupBy(state$.value), undefined, {
        includeBottomLevel: false,
        forceReload: true,
        groupingKeyOverride: 'dataIndex',
      });
      const options: ListDataOptions = { flowStatus, aggBy };

      return of(fetchProductivityData(defns.model, options));
    }),
  );
};
